export const XPlayerName = ({ name }: { name: string }) => {
  return (
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 120,
        verticalAlign: "middle",
        display: "inline-block",
      }}
    >
      {name}
    </span>
  );
};
